<style scoped>
    .label{
        display: inline-block;
        vertical-align: middle;
        width: 60px;
    }
</style>
<template>
    <div>
        <Drawer
            v-model="config.modal"
            width="640"
            title="导出"
            >
            <div class="line">
                <Button long
                    type="primary"
                    icon="md-download"
                    :loading="loading"
                    @click="exportResource"
                    >
                    导出所有员工费用科目
                </Button>
            </div>
        </Drawer>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                config: {
                    modal: false
                },
                loading: false,
                params: {
                    start: '',
                    end: ''
                },
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            show(){
                this.config.modal = true;
            },
            exportResource(){
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.export_customer_expense_type, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.config.modal = false;
                        this.$emit("done");
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>
